import BlogsContainer from "./BlogsContainer";
import BlogsStore from "./BlogsStore";

export default BlogsStore(BlogsContainer);